import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Grid, Link, Typography } from '@material-ui/core';
// import HandlingRequestForm from './HandlingRequestFrom';

// Styles
const useStyles = makeStyles((theme) => ({
  contactUs: {
    color: theme.palette.interactive.main,
  },
  subHeader: {
    color: theme.palette.interactive.main,
    fontWeight: 600,
  },
  bold: {
    fontWeight: 600,
  },
  sideBorder: {
    [theme.breakpoints.up('sm')]: {
      borderRight: 'solid',
      borderRightWidth: 2,
      borderRightColor: 'lightgrey',
    },
    [theme.breakpoints.down('sm')]: {
      borderBottom: 'solid',
      borderBottomWidth: 2,
      borderRightWidth: 0,
      borderBottomColor: 'lightgrey',
    },
  },
}));

const ContactInfo = () => {
  const classes = useStyles();
  return (
    <Box pt={14} position="relative">
      <Grid container spacing={8}>
        <Grid item xs={12} md={6} className={classes.sideBorder}>
          <Typography variant="h1" className={classes.contactUs}>CONTACT US</Typography>
          <Box mt={4} />
          <Typography variant="h6">Contact details</Typography>
          <Box mt={1} />
          <Typography variant="subtitle2" className={classes.subHeader}>Email cargo:</Typography>
          <Link href="mailto:cargo.handling@wideroe.no">
            <Typography variant="body1">cargo.handling@wideroe.no</Typography>
          </Link>
          <Box mt={1} />
          <Typography variant="subtitle2" className={classes.subHeader}>Switchboard (08:00 - 16:00 CET):</Typography>
          <Link href="tel:004775513500">
            <Typography variant="body1">+47 7551 3500</Typography>
          </Link>
          <Box mt={2} />
          <Typography variant="body2" style={{ fontWeight: 'bold' }}>For local contact information, please visit the locations page and find your airport.</Typography>
          <Box mt={3} />
          <Typography variant="h6">Visting address</Typography>
          <Box mt={1} />
          <Typography variant="body1">Widerøe Ground Handling AS</Typography>
          <Typography variant="body1">Henrik Ibsens v., Flyporten 3.etg</Typography>
          <Typography variant="body1">2060 GARDERMOEN, Norway</Typography>
          <Box mt={3} />
          <Typography variant="h6">Postal address</Typography>
          <Box mt={1} />
          <Typography variant="body1">Widerøe Ground Handling AS</Typography>
          <Typography variant="body1">Postbox 171</Typography>
          <Typography variant="body1">2061 GARDERMOEN, Norway</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="h6">Ground handling service request /AD-HOC request</Typography>
          <Box mt={2} />
          <Typography variant="body1">
            WGH ensure the best quality, service, reliability, and individual care!
            For ground handling service request and AD-HOC handling inquires please
            contact us:
          </Typography>
          <Box mt={1} />
          <Link href="mailto:handling.request@wideroe.no">
            <Typography variant="body1">
              handling.request@wideroe.no
            </Typography>
          </Link>
          {/* <HandlingRequestForm /> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ContactInfo;
